module.exports = {"data":"user","token":"sk","username":"username","permissions":"roles","modules":"menu","type":"type","subscription":"subscription","domain":"marketTypeID","billpay":"billpay","p2p":"p2p","theme":"theme","claims":"permissions","flags":"flags","created":"dateCreated"}


//////////////////
// WEBPACK FOOTER
// ./src/core/user/map.json
// module id = 81Tg
// module chunks = 13 14